import { Close, ControlPoint, ErrorOutline } from '@mui/icons-material';
import { TextField, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import CustomSelect from '../../../../reusableComponents/CustomSelect/CustomSelect';
import { customToast } from '../../../../reusableComponents/customToaster/customToast';

function PaymentDynamicForm({ partnerList, paymentDynamicField, selectedType, totalPaymentAmount, setRemainingAmount, error, setError, initialState, initiateVoidCaptureRefundError }) {
    const { fields, addField, removeField, updateField } = paymentDynamicField;
    const MAX_PERCENTAGE = 100;

    const calculateTotals = () => {
        const totalCommission = fields.reduce((sum, { commission = 0 }) => sum + Number(commission), 0);
        const totalPartnerAmount = fields.reduce((sum, { partnerAmount = 0 }) => sum + Number(partnerAmount), 0);
        return { totalCommission, totalPartnerAmount };
    };

    const validatePercentage = () => {
        const { totalCommission, totalPartnerAmount } = calculateTotals();
        const combinedTotal = totalCommission + totalPartnerAmount;
        const remainingAmount = totalPaymentAmount - ((combinedTotal / MAX_PERCENTAGE) * totalPaymentAmount);

        setRemainingAmount(Math.max(remainingAmount, 0));

        if (combinedTotal > MAX_PERCENTAGE) {
            setError('Percentages cannot exceed 100%');
        } else if (fields.length == partnerList.length && combinedTotal < MAX_PERCENTAGE) {
            setError('Percentages should sum to 100%');
        } else {
            setError('');
        }
    };

    const validateAmount = () => {
        const { totalCommission, totalPartnerAmount } = calculateTotals();
        const totalAmount = totalCommission + totalPartnerAmount;
        const remainingAmount = totalPaymentAmount - totalAmount;
        setRemainingAmount(Math.max(remainingAmount, 0));
        if (totalAmount > totalPaymentAmount) {
            setError('Amount exceeds the total amount');
        } else {
            setError('');
        }
    };

    const handleValidation = () => {
        if (selectedType === 'PERCENTAGE') {
            validatePercentage();
        } else {
            validateAmount();
        }
    };
    const handleRemoveField = (index) => {
        removeField(index); // Remove the field first
    };

    const handleShowAddButton = () => {
        if (fields?.length >= partnerList?.length) return false
        const { totalCommission, totalPartnerAmount } = calculateTotals();
        if (selectedType == "PERCENTAGE") {
            return (totalCommission + totalPartnerAmount) == 100 ? false : true
        } else {
            return (totalCommission + totalPartnerAmount) == totalPaymentAmount ? false : true

        }
    }

    const formatPartnerOptions = () => {
        const selectedPartnerList = fields.map(el => el.partner)
        return partnerList.map(el => ({ ...el, disabled: selectedPartnerList.includes(el.value) }))
    }
    const handleAddMoreFields = () => {
        const isValid = fields.every(({ partner, partnerAmount, commission }) => {
            if (!partner) return false; // Ensure partner is selected

            const amountZero = Number(partnerAmount) === 0;
            const commissionZero = Number(commission) === 0;

            // Only one of them should be zero at a time
            return !(amountZero && commissionZero) && (amountZero || commissionZero || (partnerAmount > 0 && commission > 0));
        });
        if (isValid) {

            addField(initialState)
        } else {
            customToast('error', 'high', "At least one field is required Partner amount or commission")
        }
    }

    useEffect(() => {
        handleValidation();
    }, [fields])
    return (
        <>
            {fields.map((field, index) => (
                <div key={`payment-${index}`} className="d-flex align-items-center" style={{ gap: 20, minHeight: 60 }}>
                    <div style={{ width: '40%', minWidth: 180 }}>
                        <CustomSelect
                            placeholder="Select Partner"
                            options={formatPartnerOptions()}
                            value={field.partner}
                            onChange={(value) => updateField(index, 'partner', value)}
                            style={{ width: '100%' }}
                        />
                    </div>
                    <div style={{ width: '20%', minWidth: 160 }}>
                        <TextField
                            type="number"
                            inputProps={{ min: 0, ...(selectedType === 'PERCENTAGE' && { max: 100 }) }}
                            value={field.partnerAmount}
                            onChange={(e) => updateField(index, 'partnerAmount', e.target.value)}
                            fullWidth
                            onBlur={(e) => handleValidation(index, e.target.value, 'partnerAmount')}
                            error={Boolean(error)}
                            placeholder={`00 ${selectedType === 'PERCENTAGE' ? '%' : ''}`}
                        />
                    </div>
                    <div style={{ width: '20%', minWidth: 160 }}>
                        <TextField
                            type="number"
                            inputProps={{ min: 0, ...(selectedType === 'PERCENTAGE' && { max: 100 }) }}
                            value={field.commission}
                            onChange={(e) => updateField(index, 'commission', e.target.value)}
                            fullWidth
                            onBlur={(e) => handleValidation(index, e.target.value, 'commission')}
                            error={Boolean(error)}
                            placeholder={`00 ${selectedType === 'PERCENTAGE' ? '%' : ''}`}
                        />
                    </div>
                    {fields.length > 1 && (
                        <span className="clearRuleIcons" onClick={() => { handleRemoveField(index) }}>
                            <Close style={{ height: 16, width: 16, color: "#7F7D83" }} />
                        </span>
                    )}
                </div>
            ))}

            <div className="d-flex align-items-center" style={{ gap: 20 }}>
                {error ? (
                    <div className="percentage-error-routing">
                        <ErrorOutline />
                        <Typography style={{ fontSize: 14 }}>{error}</Typography>
                    </div>
                ) : (
                    <>
                        {handleShowAddButton() && <div className="d-flex align-items-center" style={{ gap: 10, cursor: 'pointer' }} onClick={handleAddMoreFields}>
                            <ControlPoint sx={{ color: '#403E9F', fontSize: 16 }} />
                            <span style={{ color: '#403E9F', fontSize: 14 }}>Add More Partners</span>
                        </div>}
                    </>
                )}
            </div>
            {initiateVoidCaptureRefundError && <div className="percentage-error-routing">
                <ErrorOutline />
                <Typography style={{ fontSize: 14 }}>{initiateVoidCaptureRefundError}</Typography>
            </div>}
        </>
    );
}

export default PaymentDynamicForm;